<!--
---
--- View: Individual (PDF) Document from Downloads
---
-->
<template>
    <div v-if="documentId !=null">
        <my-download-document-toolbar :endOfPage="pageCount==currentPage" v-on:next="next()" v-on:back="back()"
                                      v-on:print="print()"/>

        <v-container v-if="pdfDocument">
            <div v-if="pageCount">{{currentPage}} / {{pageCount}}</div>

            <pdf id="myPdfComponent" :src="pdfDocument" v-if="pdfDocument!=null && !error"
                 @num-pages="pageCount = $event"
                 @loaded="loadingCompled"
                 @error="setError"
                 :page="currentPage"/>


        </v-container>

        <v-container v-else>
            <v-card v-if="progress==100">
                <br/>
                <p class="text-md-center">{{$t('attributes.ready')}}</p>
                <br/>
            </v-card>
        </v-container>


    </div>
</template>

<script>
    import pdf from 'vue-pdf'
    import MyDownloadDocumentToolbar from '@/components/MyDownloadDocumentToolbar'
    import MyMixin from '@/mixin'
    import WebService from '@/services/WebService'

    export default {
        name: 'my-download-document',

        components: {
            pdf, MyDownloadDocumentToolbar
        },

        mixins: [MyMixin],


        data: () => ({
            currentPage: 1,
            pageCount: null,
            pdfDocument: null,
        }),

        methods: {
            next() {
                console.log("next")
                if (this.currentPage < this.pageCount) {
                    console.log("nextX")
                    this.currentPage++;
                }
            },

            back() {
                if (this.currentPage > 1) {
                    this.currentPage--;
                } else {
                    this.$router.go(-1)
                }
            },

            setError(error) {
                this.$store.dispatch("setProcessing", false)
                this.$store.dispatch("setError", error)
            },

            loadingCompled() {
                this.$store.dispatch("setProcessing", false)
            }
        },

        computed: {
            error() {
                return this.$store.state.error
            },

            documentId() {
                return this.$route.params.downloadId;
            },

            documentInStore() {
                return this.$store.state.downloadStore[this.documentId]
            },

            progress() {
                return this.documentInStore.percent
            },

        },

        created() {
            this.$store.dispatch("setProcessing", true)
        },

        watch: {
            documentId: {
                immediate: true,
                // eslint-disable-next-line
                handler(id, oldVal) {
                    this.$store.dispatch("setProcessing", true)
                    this.pdfDocument = null

                    var download = this.$store.state.downloadStore[id]
                    if (!download.loadStarted) {
                        this.$store.dispatch('updateDownloadProgress', {id: id, loaded: 0.00001})

                        var progressCallback = (progressEvent => {
                            this.$store.dispatch("updateDownloadProgress", {id: id, loaded: progressEvent.loaded})
                        })

                        var webService = new WebService(this)
                        webService.getDownloadLink(id, progressCallback).then(url => {
                            // display pdf
                            if (id.endsWith(".pdf")) {
                                this.pdfDocument = url
                            }
                            this.$store.dispatch('updateDownloadFile', {id: id, url: url})
                            this.$store.dispatch("setProcessing", false)
                        }).catch(error => {
                            console.log(error)
                            this.$store.dispatch('setError', error)
                            this.$store.dispatch("setProcessing", false)
                        })
                    } else {
                        if (id.endsWith(".pdf")) {
                            this.pdfDocument = download.url
                        }
                        this.$store.dispatch("setProcessing", false)
                    }
                },
            },

        }
    }
</script>

